module.exports = __webpack_public_path__ + "img/17.07c2c856.png";